import { Container, Grid, Skeleton, Typography } from "@mui/material";
import React from "react";
import Section from "./Section";

function CreationDetailSingleSkeleton() {
  return (
    <Section>
      <Container>
        <Grid container columnSpacing={4}>
          <Grid item md={6} xs={12}>
            <Skeleton
              variant="rectangular"
              width="100%"
              sx={{ height: 0, paddingBottom: "100%" }}
            />
          </Grid>

          <Grid item md={6} xs={12} sx={{ mb: 3 }}>
            <Typography variant="h1">
              <Skeleton width={400} height={48} />
            </Typography>
            <Typography variant="h4">
              <Skeleton width={100} />
              <Skeleton width={300} />
            </Typography>

            <Skeleton width={400} height={150} />
            <Skeleton width={300} height={150} />
            <Skeleton width={200} height={150} />

            <Grid
              container
              item
              spacing={0}
              direction="row"
              sx={{
                justifyContent: "left",
                display: "flex",
              }}
            >
              <Skeleton
                variant="rectangular"
                width={95}
                sx={{
                  borderRadius: 3,
                  mt: 0.5,
                }}
                height={50}
              />
              <Skeleton
                variant="rectangular"
                width={130}
                sx={{
                  borderRadius: 3,
                  mt: 0.5,
                  ml: 2,
                }}
                height={50}
              />
            </Grid>
            <Skeleton width={400} height={150} />
            <Skeleton width={400} height={150} />
          </Grid>
        </Grid>
      </Container>
    </Section>
  );
}

export default CreationDetailSingleSkeleton;
